import classNames from 'classnames';
import React from 'react';

import PreventParentClickWrapper from 'ui-library/wrappers/PreventParentClickWrapper';

export interface VerticalChipListWithSpacingProps {
  chips: Array<JSX.Element>;
}

export default function VerticalChipListWithSpacing(props: VerticalChipListWithSpacingProps): JSX.Element {
  const wrappedChips = [];
  for (let i = 0; i < props.chips.length; i++) {
    wrappedChips.push(
      <div key={i} className={classNames({'u-mini-spacing-top': i > 0})}>
        <PreventParentClickWrapper>{props.chips[i]}</PreventParentClickWrapper>
      </div>
    );
  }

  return <div>{wrappedChips}</div>;
}
